import { fetcher } from '@commenda/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TaxChartClass } from '@prisma/client';
import { businessEntityKeys } from './keys';

// taxChartClass null clears the override. The shape is resolved server-side, so refetch org-structure after mutating.
// onError is wired at the mutation level (not the mutate() call) so callers still hear failures even if their
// component unmounts before the request settles — e.g. Reset lives in a hover popover that can close mid-request.
export function useSetTaxChartClassOverride(companyId: number, opts?: { onError?: (error: Error) => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ entityId, taxChartClass }: { entityId: number; taxChartClass: TaxChartClass | null }) => {
      const res = await fetcher(`business-entities/${entityId}`, {
        method: 'PATCH',
        body: { taxChartClassOverride: taxChartClass },
      });
      if (!res.ok) {
        const body = (await res.json().catch(() => ({}))) as { message?: string };
        throw new Error(body.message || 'Failed to update entity shape');
      }
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [businessEntityKeys.FETCH_COMPANY_ORG_STRUCTURE, companyId] });
    },
    onError: opts?.onError,
  });
}
